<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Select a layout section') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <label for="layout">{{ _('Layout section') }}</label><br />
            <select class="form-control" v-model="layoutId">
              <option v-for="l in layouts" :value="l.id">{{ l.id }}: {{ l.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-info pull-left" v-if="isFeatureEnabled('uifeatures')" v-on:click="openUiFeatures"><i class="fa fa-fw fa-clone"></i> {{ _('Ready-made screens') }}</button>
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selectLayout"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'
import settingshelpers from '~/lib/settingshelpers'

export default {
  props: ['selectedLayouts'],
  mixins: [settingshelpers],
  data () {
    return {
      layoutId: null,
      layouts: []
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey', 'allSettings', 'locale']),
    settings () {
      return this.allSettings && this.shopId ? this.allSettings[this.shopId + '-' + this.locale] : null
    },
    selectedLayoutIds () {
      return this.selectedLayouts.map(l => l.id)
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectLayout () {
      this.$emit('selectLayout', this.layoutId)
    },
    openUiFeatures () {
      this.$emit('openUiFeatures')
    }
  },
  async mounted () {
    let response
    try {
      response = await axios.get(this.baseDomain + this.shopId + '/layouts.json?iSortingCols=1&iSortCol_0=1&sSortDir_0=asc&apikey=' + this.apiKey)
    } catch(e) {}
    this.layouts = response.data.filter(layout => {
      return this.selectedLayoutIds.indexOf(layout.id) === -1 // Only list layouts that are not already added to the client
    })
  }
}
</script>